module.exports = __webpack_public_path__ + "static/fdmmodel-29b9a08a9321f83688867a821c3cb3d4.jpg";